import React from 'react';
import './FaqPage.css';

import { PageTitle, Faqs, Heading } from '../../../components';
import { faqsContent, images } from '../../../constants';



const FaqPage = () => { 

  return (
    <> 
      {/* Page title */}
      <PageTitle title={'faqs'} page={'faqs'} />

      <section className='faq-page'>

        {/* Section heading */}
        <Heading title={'Frequently Asked Questions'} subTitle={"FAQ's"} />

        <div className='box-container'>

          {/* Faq Accordion container */}
          <Faqs faqs={faqsContent} />

          {/* Faq Image */}
          <div className='image'>
            <img src={images.FAQs} alt='FAQs-Pic' />
          </div>

        </div>

      </section>
    </>
  );
};

export default FaqPage;